module.exports = __webpack_public_path__ + "img/gamesdk25.016f82c.png";